import { Row } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import { getAllKorbaAssistance } from "../../../apis/actions/korba.actions";
import { toGetServicesRequests } from "../../../apis/actions/services.actions";
import Selects from "../../../biblio/Selects/Selects";
import PaginationComponent from "../../../biblio/Pagination/PaginationComponent";
import ServicesRequestsCollapse from "./ServicesRequestsCollapse";
import { scroll } from "../../../components/utils/utils";
import DotsLoader from "../../../biblio/Loader/DotsLoader";
import CustomConfigProvider from "../ProfileHeader";
const ServicesRequests = () => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);

  const { servicesRequests, loading, TotalServices } = useSelector(
    (state: RootState) => state?.services
  );

  const { korbaAssitances } = useSelector((state: RootState) => state?.korbas);
  useEffect(() => {
    dispatch(getAllKorbaAssistance());
  }, [dispatch]);
  const [selectedFilter, setSelectedFilter] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };
  useEffect(() => {
    setCurrentPage(1);
  }, [selectedFilter]);
  useEffect(() => {
    dispatch(
      toGetServicesRequests({
        limit: itemPerPage,
        page: currentPage,
        assistance_id: selectedFilter,
      })
    );
  }, [dispatch, currentPage, selectedFilter]);

  const itemPerPage = 8;

  const handleSelectChange = (value: any) => {
    if (value) {
      setSelectedFilter(value.value);
      setCurrentPage(1);
    } else {
      setSelectedFilter(null);
    }
  };

  return (
    <>
      <CustomConfigProvider title="طلبات الخدمات">
        <Selects
          options={korbaAssitances}
          selectPlaceholder="نوع الخدمة"
          onChange={handleSelectChange}
          allowClear={true}
          className="takaful--service-select takaful--request-select"
          popupClassName="takaful--service-select-dropdown"
        />
      </CustomConfigProvider>
      {loading ? (
        <div className="takaful--loading-projects-cases">
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : servicesRequests?.length === 0 && !selectedFilter ? (
        <p className="takaful--no-services">لا توجد خدمات</p>
      ) : servicesRequests?.length === 0 && selectedFilter ? (
        <p className="takaful--no-services">
          لا يوجد خدمات تتوافق مع البحث الذي قمت به
        </p>
      ) : (
        <>
          <Row gutter={[16, 48]} justify={"space-around"} ref={currentRef}>
            <ServicesRequestsCollapse collapseData={servicesRequests} />
          </Row>
          <div className="takaful--pagination-container">
            {servicesRequests &&
              Math.ceil(TotalServices) * itemPerPage > itemPerPage && (
                <PaginationComponent
                  active={currentPage}
                  total={Math.ceil(TotalServices) * itemPerPage}
                  itemPerPage={itemPerPage}
                  scroll={() => scroll(currentRef)}
                  setActive={(nb) => updateActive(nb)}
                />
              )}
          </div>
        </>
      )}
    </>
  );
};

export default ServicesRequests;
